import React from 'react'
import altImage from '../images/movie_alternate.jpg'


const IMG_API = "https://image.tmdb.org/t/p/w1280";

const Movie = ({ title, poster_path, overview, vote_average }) => {

    const voteColor = (vote) => {
        if (vote <= 5) {
            return (
                <p style={{ color: "red" }}>{vote} </p>
            )
        } else if (vote > 5 && vote <= 8) {
            return (
                <p style={{ color: "orange" }}>{vote} </p>
            )
        } else if (vote > 8) {
            return (
                <p style={{ color: "green" }} >{vote} </p>
            )
        }
    }

   

    return (
        <div  className="movie">
            <img src={( poster_path ? IMG_API + poster_path : altImage )} alt={title} />
            <div className="movie-info">
                <h3>{title} </h3>
                <span className="vote">{voteColor(vote_average)} </span>
            </div>
            <div className="movie-over">
                <h2>Overview</h2><hr />
                <p>{overview} </p>
            </div>

        </div>
    )
}

export default Movie
